import type { FunctionComponent } from "react";

import Button from "~/components/buttons/Button";
import CardContent from "~/components/Card/components/CardContent";
import CardHeader from "~/components/Card/components/CardHeader";
import CardTitle from "~/components/Card/components/CardTitle";
import CardWrapper from "~/components/Card/components/CardWrapper";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import { invoiceTypeId } from "~/modules/billing/api/invoiceType.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";

type Props = { invoiceData: Invoice, onUpdateClick?: () => void };

const InvoiceRecipientSection: FunctionComponent<Props> = ({ invoiceData, onUpdateClick }) => {
	const isSelfBilledInvoice = invoiceData.invoiceTypeId === invoiceTypeId.SelfBilledInvoice;
	const recipientOrSenderInformation = isSelfBilledInvoice ? invoiceData.senderInformation : invoiceData.recipientInformation;
	return <CardWrapper hasTitle={true}
						padding="none">
		<CardHeader hasTitle={true}>
			<CardTitle>{isSelfBilledInvoice ? "Rechnungssteller" : "Rechnungsempfänger"}</CardTitle>
			{onUpdateClick && <Button size="auto"
									  theme="plain"
									  className="px-2 py-1 text-xs"
									  onClick={onUpdateClick}>Bearbeiten</Button>}
		</CardHeader>
		<CardContent padding="none">
			<div className="gap-x-4 gap-y-2 px-4 py-3 text-sm">
				{recipientOrSenderInformation || EMPTY_VALUE_PLACEHOLDER}
			</div>
		</CardContent>
	</CardWrapper>;
};

export default InvoiceRecipientSection;